<template>
  <div class="content">
    <ColumnTitle title="Contact"></ColumnTitle>
  <el-descriptions title="Professor Wei Chen" column="1" border>
    <el-descriptions-item label="Department">Department of Applied Chemistry</el-descriptions-item>
    <el-descriptions-item label="">School of Chemistry and Materials Science</el-descriptions-item>
    <el-descriptions-item label="">University of Science and Technology of China</el-descriptions-item>
    <el-descriptions-item label="Address">96 Jinzhai Road, Hefei, Anhui 230026, China</el-descriptions-item>

    <el-descriptions-item label="Email">weichen1@ustc.edu.cn</el-descriptions-item>
    <el-descriptions-item label="Office">Room 231, Environment and Resources Building, EAST Campus of USTC</el-descriptions-item>
    <el-descriptions-item label="">安徽省合肥市包河区金寨路96号 中国科学技术大学东校区环资楼231室</el-descriptions-item>
    <el-descriptions-item label="邮编">230026</el-descriptions-item>
    <el-descriptions-item label="电子邮件">weichen1@ustc.edu.cn</el-descriptions-item>
  </el-descriptions>
  </div>
</template>

<script>
import ColumnTitle from "@/components/ColumnTitle";
export default {
  name: "Contact",
  components: {ColumnTitle}
}
</script>

<style scoped>
.content{
  width: 80%;
  margin:auto;
}
</style>